import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrHelper } from '../../../../helpers/toastr.helper';
import { ProjectParticipation } from '../../../../models/projects/project-participation.enum.model';
import { FiltersItem } from '../../../../models/shared/filters-item.model';
import { AccountsService } from '../../../../services/identity/accounts.service';
@Component({
    selector: 'app-project-participate-filters-dropdown',
    templateUrl: './project-participate-filters-dropdown.component.html',
})
export class ProjectParticipateFiltersDropdownComponent implements OnInit {
    @Output() ready = new EventEmitter();
    @Output() selectionChanged = new EventEmitter();

    projectInvolvedUserFilterItems: FiltersItem[];
    constructor(private readonly toastrHelper: ToastrHelper, private translate: TranslateService, private accountService: AccountsService) {}

    ngOnInit(): void {
        this.loadProjectInvolvedByUserId();
    }
    loadProjectInvolvedByUserId() {
        this.projectInvolvedUserFilterItems = [
            new FiltersItem('InvolvededProjects', this.translate.instant('filters.project.projectsIParticipate')),
            new FiltersItem('CanJoin', this.translate.instant('filters.project.projectsICanJoin')),
        ];
        this.ready.emit();
    }
    setSelectedFilters() {
        this.projectInvolvedUserFilterItems.forEach((item) => item.checked);
    }

    onFilterSelectionChanged(selectedItem: FiltersItem) {
        this.projectInvolvedUserFilterItems.forEach((item) => {
            if (item !== selectedItem) {
                item.checked = false;
            }
        });

        this.selectionChanged.emit();
    }

    resetFilters(): void {
        this.projectInvolvedUserFilterItems.forEach((item) => (item.checked = false));
    }

    public getProjectParticipation(): ProjectParticipation {
        const checkedItem = this.projectInvolvedUserFilterItems.find((item) => item.checked);
        return checkedItem ? ProjectParticipation[checkedItem.key as keyof typeof ProjectParticipation] : ProjectParticipation.AllProjects;
    }
}
